import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import faker from 'faker';
import mockData from '../mockData'
import GenericTitleP from '../../titles/GenericTitleP';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: 'Revenue - Quarterly (1000$)',
    },
  },
};

const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];

const labels = Object.keys(mockData[0].dates).map(x => `${monthNames[(new Date(x).getMonth())]} ${(new Date(x).getFullYear())}`)

export const data = {
  labels,
  datasets: [
    {
      fill: true,
      label: 'Revenue',
      data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
      borderColor: 'rgb(53, 162, 235)',
      backgroundColor: 'rgba(53, 162, 235, 0.5)',
    },
  ],
};

const AreaChart = () => {
  return <div className='d-block d-md-none'>
    <GenericTitleP>Sales For Each Item (Quarterly)</GenericTitleP>
    <Line  options={options} data={data} />
  </div>
}

export default AreaChart;